<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="courseTip"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="模板名称" prop="title">
        <el-input
          v-model="courseTip.title"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入课卡名称"
        />
      </el-form-item>

      <el-form-item label="模板内容" prop="tip">
        <el-input
          type="textarea"
          :autosize="{ minRows: 10, maxRows: 20}"
          v-model="courseTip.tip"
          maxlength="2000"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="课卡预约退课须知" prop="cancel_tip_card">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          v-model="courseTip.cancel_tip_card"
          maxlength="140"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="微信支付退课须知" prop="cancel_tip_we_chat_pay">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          v-model="courseTip.cancel_tip_we_chat_pay"
          maxlength="140"
          show-word-limit
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.courseTipList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/course-tip';

export default {
  name: RouteConfig.courseTipAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseTip: {
      title: '',
      tip: '',
      cancel_tip_card: '',
      cancel_tip_we_chat_pay: '',
    },
    rules: {
      title: [{ required: true, message: '请输入模板名称', trigger: 'change' }],
      tip: [{ required: true, message: '请输入模板内容', trigger: 'change' }],
      cancel_tip_card: [{ required: true, message: '请输入课卡预约退课须知', trigger: 'change' }],
      cancel_tip_we_chat_pay: [{ required: true, message: '请输入微信支付退课须知', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await store(this.courseTip);
        this.isSaving = false;
        if (!isError) RouteConfig.courseTipList.push();
      });
    },
  },
};
</script>
